<template lang="html">
  <v-layout
    ref="me"
    ma-0
    pa-0
    justify-center
  >
    <v-responsive
      v-show="!hasImage"
      :aspect-ratio="1"
      v-bind="$attrs"
    >
      <v-hover v-slot="{ hover }">
        <v-card
          class="si-image-holder-wrapper fill-height cursor-pointer"
          flat
          color="transparent"
          :ripple="{ class: `${color}--text` }"
          @click.native="pickImage"
        >
          <div
            v-if="!isUploading"
            class="si-image-holder-wrapper fill-height"
            :style="pickerStyle(hover)"
          >
            <v-layout
              ma-0
              pa-0
              row
              justify-center
              align-center
              fill-height
            >
              <v-flex
                ma-0
                pa-0
                shrink
                text-xs-center
              >
                <v-icon
                  slot="activator"
                  large
                  :color="color"
                >
                  add_photo_alternate
                </v-icon>
              </v-flex>
            </v-layout>
          </div>
        </v-card>
      </v-hover>
    </v-responsive>

    <v-flex
      v-if="hasImage"
      pa-0
    >
      <v-img
        class="si-image"
        :src="displayImage.src" 
        :lazy-src="displayImage.lazySrc"
        :aspect-ratio="displayAspectRatio"
        v-bind="$attrs"
        @contextmenu="contextMenu"
        @click="contextMenu"
        @load="handleLoad"
        @error="handleError"
      >
        <v-flex pa-0>
          <v-fade-transition>
            <v-overlay
              v-if="isUploading"
              absolute
            >
              <v-progress-circular
                :indeterminate="progress === 101"
                :active="isUploading"
                :value="progress"
                color="white"
                width="2"
              />
            </v-overlay>
          </v-fade-transition>
        </v-flex>
      </v-img>
    </v-flex>
    <input
      ref="upload"
      type="file"
      name="image"
      accept="image/*"
      @change="imagePicked"
      @click.stop=""
    >

    <v-menu
      v-model="menuShow"
      :position-x="menuX"
      :position-y="menuY"
      absolute
      offset-y
    >
      <v-list>
        <v-list-item
          v-for="(item, index) in menuItems"
          :key="index"
          @click="item.cb"
        >
          <v-list-item-icon><v-icon>{{ item.icon }}</v-icon></v-list-item-icon>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <div
      ref="colorsample"
      :class="{[color]: true}"
      style="height:0px; width:0px; opacity:0"
    />
  </v-layout>
</template>

<script>
// import { mapGetters } from 'vuex'
import uniqid from 'uniqid'
import { rtdb, storage } from '@/plugins/firebase'
import helpers from '@/mixins/helpers'
import colorParser from '@/mixins/color-parser'

export default {
  mixins: [ helpers, colorParser ],
  props: {
    image: Object,
    savePath: {
      type: String,
      required: true
    },
    registerPaths: {
      type: Array,
      default: () => []
    },
    registerPathKey: {
      type: String, 
      default: 'image'
    },
    color: {
      type: String,
      default: 'info'
    },
    aspectRatio: Number,
    border: Boolean,
    holderMaxWidth: [ String, Number ],
    size: [ String, Number ],
    holderMaxHeight: [ String, Number ]
  },
  data () {
    return {
      loadError: false,
      computedAspectRatio: undefined,
      progress: 0,
      placeholderSrc: '',
      uploadedImage: null,
      changingImage: false,
      isUploading: false,
      computedColor: '',
      menuShow: false,
      menuX: 0,
      menuY: 0,
      menuItems: [
        { icon: 'add_photo_alternate', text: 'Replace Image', cb: this.changeImage },
        { icon: 'delete', text: 'Delete Image', cb: this.removeImage }
      ]
    }
  },
  computed: {
    // ...mapGetters([]),
    displayImage () {
      return this.placeholderSrc
        ? { src: this.placeholderSrc }
        : this.image 
          ? this.image
          : {} 
    },
    displayAspectRatio () {
      return this.aspectRatio || this.computedAspectRatio
    },
    hasImage () {
      return !this.loadError && Boolean(this.displayImage.src)
    }
  },
  watch: {
    image () {
      // this.isActive = false
      // this.$nextTick(() => { this.isActive = true })
    }
    // 'image.src': {
    //   handler (v) {
    //     if (v) this.loadImage()
    //   },
    //   immediate: true
    // }
  },
  mounted () {
    this.computedColor = window
        .getComputedStyle(this.$refs.colorsample)
        .getPropertyValue('background-color')
    
    if (this.$refs.me && this.$refs.me.parentNode.classList.contains("v-avatar")) {
      this.computedAspectRatio = 1
    }
  },
  methods: {
    pickerStyle (hover) {
      var style = hover ? 'solid' : 'dashed'
      var border =
      `border-radius: 4px;
      border-color: ${this.computedColor};
      border-width: 1px;
      border-style: ${style};`
      return this.border ? border : ''
    },
    contextMenu (e) {
      if ((e.type === 'click' && !this.displayImage.src) || this.isUploading) return

      e.preventDefault()
      this.menuShow = false
      this.menuX = e.clientX
      this.menuY = e.clientY
      this.$nextTick(() => {
        this.menuShow = true
      })
    },
    handleLoad (e) {
      this.$emit('load', e)
    },
    handleError () {
      console.log('error loading image');
      this.loadError = true
    },
    pickImage () {
      this.$refs.upload.click()
    },
    resetInput () {
      const input = this.$refs.upload
      input.type = 'text'
      input.type = 'file'
    },
    setImagePreview (file) {
      var reader = new FileReader()

      reader.addEventListener('load', () => {
        this.placeholderSrc = reader.result
      }, false)

      reader.readAsDataURL(file)
    },
    async imagePicked (e) {
      const files = e.target.files || e.dataTransfer.files

      if (!(files && files[0])) {
        return this.resetInput()
      }

      this.loadError = false

      if (this.changingImage) {
        this.removeImage(null)
        this.changingImage = false
      }

      let file = files[0]
      let name = uniqid()
      let extension = file.name.split('.')[1]
      let filename = `${name}.${extension}`
      const path = `${this.savePath}/${filename}`
      const thumbPath = `${this.savePath}/thumb_${filename}`
      const details = { path }

      this.setImagePreview(file)
      this.progress = 0
      this.isUploading = true

      let uploadTask = storage.ref(path).put(file)

      let fileUpload = { 
        uploadTask, 
        state: 'running', 
        progress: 0, 
        bytesTransferred: 0 
      }

      this.$emit('on-upload', fileUpload, details)

      uploadTask.on('state_changed', s => {
        let progress = s.totalBytes ? (s.bytesTransferred / s.totalBytes) * 100 : 100 
        
        this.progress = progress
        fileUpload.progress = progress
        fileUpload.bytesTransferred = s.bytesTransferred
        fileUpload.state = s.state
        console.log('Upload is ' + (s.bytesTransferred / s.totalBytes) * 100 + '% done')

        this.$emit('on-upload', fileUpload, details)
      }, error => {
        console.error(error);
        fileUpload.state = error.code === 'storage/canceled' ? 'canceled' : 'error'
        this.$emit('on-upload', fileUpload, details)
      }, async () => {
        this.progress = 101

        const src = await uploadTask.snapshot.ref.getDownloadURL()
        const lazySrc = await this.getThumbnail(thumbPath)

        details.src = src
        details.lazySrc = lazySrc

        this.$emit('on-upload', fileUpload, details)

        this.resetInput()

        await this.registerImage(details)
        
        this.$emit('update:image', details)

        this.isUploading = false

        await this.preLoadImage(src)
        
        this.placeholderSrc = ''
      })
    },
    async getThumbnail (path) {
      return new Promise((resolve) => {
          async function retrieve (retry = 0) {
            try {
              let src = await storage.ref(path).getDownloadURL()
              resolve(src)
            } catch (error) {
              if (retry < 20) {
                setTimeout(() => retrieve(retry + 1), 200);
              } else {
                resolve('')
              }
            }
          }
          retrieve()
        }) 
    },
    async registerImage (details) {
      let updates = {}

      this.registerPaths.forEach(path => {
        updates[`${path}/${this.registerPathKey}`] = details
      })

      return await rtdb.ref().update(updates)
    },
    async preLoadImage (src) {
      try {
        if (src) {
          let preLoad = new Promise((resolve, reject) => {
            let img = new Image()
            img.onload = resolve
            img.onerror = reject
            img.src = src
          })
          await preLoad
          return src
        }
        return null
      } catch (error) {
        return null
      }
    },
    changeImage () {
      this.changingImage = true
      this.pickImage()
    },
    removeImage () {
      this.registerImage(null)
      this.placeholderSrc = ''
      if (this.image) storage.ref(this.image.path).delete()
    }
  }
}
</script>

<style lang="css" scoped>
.si-image {
  width: 100% !important;
  height: 100% !important;
}
input[type=file] {
    position: absolute;
    left: -99999px;
    opacity:0;
    height: 100%;
    width: 100%;
    /* top: 0;
    left: 0; */
}
.v-avatar:not(.v-avatar--tile) .si-image-holder-wrapper,
.v-avatar:not(.v-avatar--tile) .si-image{
  border-radius: 50% !important;
}

.si-image-holder-wrapper {
  width: 100%
}
</style>
